import { SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useStartResetPassword } from 'shared/data/webApp/v1';
import { getUrl, Path } from 'urlBuilder';

import { Loading } from './loading';
import { Content } from './resources/components';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const history = useHistory();
    const [linkCode] = hooks.useQueryParam('linkCode');

    const { data, mutate, isLoading } = useStartResetPassword({
        onError: () => history.push(getUrl(Path.login)),
    });

    useEffect(() => {
        mutate({ body: { linkCode } });
    }, [linkCode, mutate]);

    return (
        <SimpleLayout size='small'>
            <Helmet>
                <title>{messages.title}</title>
            </Helmet>

            <SimpleLayout.Content>
                {isLoading || !data ? <Loading /> : <Content startData={data} />}
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

export default Page;
